var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Tooltip, Typography, theme } from '@robinpowered/ui-kit';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCopy, } from '@awesome.me/kit-cf858715fd/icons/classic/regular';
export var EventIdRow = function (_a) {
    var eventId = _a.eventId;
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var _b = __read(useState(false), 2), copied = _b[0], setCopied = _b[1];
    var timerRef = useRef(null);
    useEffect(function () {
        return function () {
            if (timerRef.current)
                clearTimeout(timerRef.current);
        };
    }, []);
    var handleCopy = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(eventId)];
                case 1:
                    _b.sent();
                    setCopied(true);
                    if (timerRef.current)
                        clearTimeout(timerRef.current);
                    timerRef.current = setTimeout(function () { return setCopied(false); }, 1500);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Tooltip, { title: copied ? t('eventDetails.copied') : t('eventDetails.copy_to_clipboard'), trigger: ['hover', 'focus'], placement: "top", children: _jsxs(EventIdRowContainer, { role: "button", tabIndex: 0, "aria-label": "".concat(t('eventDetails.event_id', {
                id: eventId,
            }), ", ").concat(t('eventDetails.copy_to_clipboard')), onClick: handleCopy, onKeyDown: function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleCopy();
                }
            }, children: [_jsx(Typography.Text, { size: "small", className: "event-id-text", style: { color: token.colorTextPlaceholder }, children: t('eventDetails.event_id', { id: eventId }) }), _jsx(FontAwesomeIcon, { icon: copied ? faCheck : faCopy, size: "sm", color: copied ? token.colorSuccess : token.colorTextPlaceholder, className: "event-id-copy-icon", style: copied ? { opacity: 1 } : undefined })] }) }));
};
var EventIdRowContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  width: fit-content;\n  max-width: 100%;\n\n  .event-id-text {\n    min-width: 0;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .event-id-copy-icon {\n    flex-shrink: 0;\n    opacity: 0;\n    transition: opacity 0.12s ease;\n  }\n\n  &:hover .event-id-copy-icon,\n  &:focus-visible .event-id-copy-icon {\n    opacity: 1;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  width: fit-content;\n  max-width: 100%;\n\n  .event-id-text {\n    min-width: 0;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .event-id-copy-icon {\n    flex-shrink: 0;\n    opacity: 0;\n    transition: opacity 0.12s ease;\n  }\n\n  &:hover .event-id-copy-icon,\n  &:focus-visible .event-id-copy-icon {\n    opacity: 1;\n  }\n"])));
var templateObject_1;
